import { BsNavigator } from './BsNavigator';
export default BsNavigator;
